import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import configuration from 'services/rest/config';
import { getToken } from 'utils/axios-request';
import { ClientsState } from './definitions';
import { Client, GroupEntity, Work, Workday } from 'interfaces';

export const fetchClient = createAsyncThunk(
  'client/fetchClient',
  (id: string) =>
    axios
      .get<Client[]>(`${configuration.miniServerURL}/clientHandler`, {
        params: { id },
        headers: { ...getToken() },
      })
      .then((resp) => {
        return resp?.data?.[0];
      })
);

export const fetchGroupEntities = createAsyncThunk(
  'clients/fetchGroupEntities',
  (_, { getState }) => {
    const {
      clients: { groupEntities },
    } = getState() as {
      clients: ClientsState;
    };

    if (groupEntities.data.length) {
      return groupEntities.data;
    }

    return axios
      .get<GroupEntity[]>(`${configuration.miniServerURL}/groupEntities`, {
        headers: { ...getToken() },
      })
      .then((resp) => resp.data);
  }
);

export const fetchWorks = createAsyncThunk(
  'client/fetchWorks',
  (clientId: string) =>
    axios
      .get<Work[]>(`${configuration.miniServerURL}/works`, {
        params: { clientId },
        headers: { ...getToken() },
      })
      .then((resp) => resp.data)
);

export const fetchWorkday = createAsyncThunk(
  'client/fetchWorkday',
  (client: string) =>
    axios
      .get<Workday[]>(`${configuration.miniServerURL}/workday`, {
        params: { client },
        headers: { ...getToken() },
      })
      .then((resp) => resp.data)
);
